<template>
    <span class="material-symbols-outlined pr-1" :class="classes">{{ nome }}</span>
</template>

<script>
import { defineComponent, ref } from 'vue';
export default defineComponent({
    name: 'Icone',
    props: {
        nome: {
            type: String,
            required: true
        },
        classesAdicionais: {
            type: [],
            default: []
        }
    },
    setup(props) {
        const classes = ref('')
        if (props.classesAdicionais.length > 0) {
            classes.value = props.classesAdicionais.join(' ')
        }

        return { classes }
    }
});
</script>